'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { pruneData } = require('../../../modules/support/prune-data');

const SharedModal = require('../../shared/views/shared-modal');
const RedemptionRedeem = require('../../redemption/views/redemption-modal-redeem');
const RedemptionTerms = require('../../redemption/views/redemption-modal-terms');
const RedemptionAlert = require('../../redemption/views/redemption-modal-alert');

const { publish, subscribe } = require('../../support/event-observer');
const { getOfferRedemptionData } = require('../../support/redemption-helper');
const { withReduxWrapper } = require('../../support/redux-helper');

class RedemptionProvider extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      redemptionData: null,
    };

    this.setRedemptionData = this.setRedemptionData.bind(this);
  }

  componentDidMount() {
    subscribe('@redemption', this.setRedemptionData);

    this.getDirectRedemption();
  }

  render() {
    const { directRedemption, referralSource } = this.props;
    const { redemptionData } = this.state;

    return withReduxWrapper(
      redemptionData &&
        h(SharedModal, this.getModalProps(), this.getModalContent()),
      {
        directRedemption,
        referralSource,
      }
    );
  }

  setRedemptionData(data) {
    this.setState({
      redemptionData: data,
    });
  }

  getModalProps() {
    const { redemptionData } = this.state;

    const closeHandler = () => {
      publish('@redemption', null);

      window.history.replaceState(
        {},
        '',
        window.location.href.replace(window.location.search, '')
      );
    };
    const className =
      redemptionData.type === 'REDEEM' || redemptionData.type === 'TERMS'
        ? 'redemption-modal-redeem'
        : 'redemption-modal-alert';

    return {
      className,
      closeHandler,
    };
  }

  getModalContent() {
    const { routes, referralSource, directRedemption } = this.props;

    const { redemptionData } = this.state;
    const props = {
      referralSource,
      directRedemption,
      ...redemptionData,
    };

    switch (redemptionData.type) {
      case 'REDEEM':
        props.routes = pruneData(routes, 'redirect');
        return h(RedemptionRedeem, props);
      case 'TERMS':
        props.routes = pruneData(
          routes,
          'outlink:main',
          'redemption:main',
          'redirect:merchant'
        );
        return h(RedemptionTerms, props);
      default:
        return h(RedemptionAlert, props);
    }
  }

  getDirectRedemption() {
    const { directRedemption } = this.props;

    if (!directRedemption) {
      return;
    }

    const data = getOfferRedemptionData(directRedemption);

    this.setRedemptionData(data);
  }
}

module.exports = hydrate('RedemptionProvider', RedemptionProvider);
